import { useState } from "react"
import { BiPlus } from "react-icons/bi"
import { RiArrowDownSLine } from "react-icons/ri"
import { hasPermission } from "utils/HasPermission"

interface Toggle {
  name: string
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  permission?:string
}
interface PropAddButton {
  text?: string
  rightIcon?: JSX.Element
  leftIcon?: JSX.Element
  ToggleOptions?: Toggle[]
  className?: string
  WrapperClassName?: string

}

const AddButton = ({
  text = "افزودن",
  rightIcon = <BiPlus size={23} />,
  leftIcon = <RiArrowDownSLine size={23} />,
  ToggleOptions = [],
  className,
  WrapperClassName,
}: PropAddButton) => {
  const [toggle, setToggle] = useState(false)

  const handleBlur = (e: {
    currentTarget: { contains: (arg0: any) => any }
    relatedTarget: any
  }) => {
    if (!e.currentTarget.contains(e.relatedTarget)) setToggle(false)
  }



  return (
    <div className={`relative ${WrapperClassName}`} onBlur={handleBlur}>
      <button
        className={`btn w-full ${className}`}
        onClick={() => setToggle(!toggle)}
      >
        <span>{rightIcon}</span>
        <span>{text}</span>
        <span
          className={`${toggle && "rotate-180"} transition-all duration-500`}
        >
          {leftIcon}
        </span>
      </button>
      {toggle
        ? ToggleOptions?.length > 0 && (
            <div className='ToggleContainer'>
              {ToggleOptions.map(
                (item, index) =>
                  (!item.permission || hasPermission(item.permission)) && (
                    <button
                      key={index}
                      className='ToggleElements'
                      onClick={item.handleClick}
                    >
                      {item.name}
                    </button>
                  )
              )}
            </div>
          )
        : null}
    </div>
  )
}

AddButton.defaultProps = {
  WrapperClassName: "w-44",
  className: "full-tomato-btn gap-5",
}

export default AddButton
